module.exports = __webpack_public_path__ + "staticcomp/img/cover.3ab4a41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/6/cover.jpg
// module id = r4gZ
// module chunks = 39